export const BOARD_TITLES = {
  105: '편집회의',
}

export function getBoardTitle(tbcode, fallback = '') {
  return BOARD_TITLES[tbcode] || BOARD_TITLES[String(tbcode)] || fallback
}
